export class Consolidado {
  codigoPolo?: number;
  codigoDiretoria?: number;
  codigoEscola?: number;
  codigoSubCategoria?: number;
  codigoPerfil?: number;
  codigoUsuario?: number;
  nomeUsuario?: string;
  codigoPsicologo?: number;
  dataInicio?: Date;
  dataFim?: Date;
  codigoAtivo?: boolean;
  somenteDivergencia?: boolean;
  statusPlanoMelhoria?: number | null;
  ano?: number;
  mes?: number;
  codigoTipoIdentificador?: number;
}
